import React, { Component } from "react";
import Select from 'react-select';
import { AsyncPaginate } from 'react-select-async-paginate';
import { DateRangePicker, CustomProvider } from 'rsuite';
import enUS from 'rsuite/locales/en_US';
import { callBackendAPI, handleFormValidation, handleFormInputs, generateSource } from './../../helpers/common';
import { STATUS_SUCCESS, DATE_RANGE_PICKER_FORMAT, RADIO_YES, CALENDAR_DATE_TIME_FORMAT } from './../../config/global_constants';
import { translate, formatDate } from './../../helpers/intl_helpers';
import infoIcon from './../../assets/images/info-icon-yellow.svg';


const locale = {
	...enUS,
	DateTimeFormats: {
		...enUS.DateTimeFormats,
		weekStart: 0 // Sunday
	}
};

export default class AddEmployee extends Component {
	constructor(props) {
		super(props)

		const { weekData, skillId } = this.props;

		let startDate = weekData?.from ? weekData?.from : new Date();
		let endDate = weekData?.to ? weekData?.to : new Date();

		this.state = {
			errors: {},
			fields: {
				start_date: { value: startDate },
				end_date: { value: endDate },
				date_range: [new Date(startDate), new Date(endDate)],
				is_hide_weekend_date: { value: String(RADIO_YES) },
				skill_id: skillId ? { value: skillId || "" } : '',
			},
			skillList: [],
			empIdsWithoutSkills: [],
			employeeSkillMap: {},
			isSkillValidationMode: false,

			submitted: false,
			bulkErrors: null,
			modalType: this.props.modalType,

		};

		this.closeModal = this.closeModal.bind(this);
		this.handleFormInputs = this.handleFormInputs.bind(this);
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
		this.loadOptions = this.loadOptions.bind(this);
		this.loadOptionsJobs = this.loadOptionsJobs.bind(this);
	}

	componentDidMount() {
		const { skillId } = this.props;
		window.document.body.classList.add("modal-open");
		window.document.body.classList.add("overflow-hidden");

		if (!skillId) this.getSkillList();
	}

	getSkillList = () => {
		this.source = generateSource();
		window.showLoader();
		callBackendAPI([{ model: 'home', method: 'masterData', type: "skill_set", show_on_schedule: true }], this.source).then(response => {
			window.hideLoader();
			if (response.success && response.data[0].status === STATUS_SUCCESS && response.data[0].result) {
				this.setState({ isLoading: false, skillList: response.data[0].result || [] });
			}
		}).catch(err => console.log(err));
	}

	/**
	* For load project manager options
	*
	* @param inputValue		as 	search term
	* @param loadedOptions	as 	old options array
	* @param page			as 	page count
	*
	* @return json
	*/
	async loadOptions(inputValue, loadedOptions, { page }) {
		try {
			/** Generate source for cancel token */
			this.source = generateSource();

			const { weekData, skillId } = this.props;
			let startDate = weekData?.from ? weekData?.from : new Date();
			let endDate = weekData?.to ? weekData?.to : new Date();

			let response = await callBackendAPI([{ model: 'calendar', method: 'employeeList', onCallSchedule: true, start_date: startDate, end_date: endDate, skill_id: skillId, is_project_manager: true, current_page: page, emp_name: inputValue ? inputValue : '' }], this.source);

			let resData = response && response.data && response.data[0] ? response.data[0] : {};
			let result = resData.result ? resData.result : [];
			let recordsTotal = resData.recordsTotal ? resData.recordsTotal : 0;
			let completeArray = result.concat(loadedOptions);

			return {
				options: result,
				hasMore: completeArray.length === recordsTotal ? false : true,
				additional: { page: page + 1 },
			}

		} catch (error) {
			console.error('Error loading options:', error);
			return {
				options: [],
				hasMore: false,
				additional: { page: page },
			};
		}
	}

	/**
	* For load project manager options
	*
	* @param inputValue		as 	search term
	* @param loadedOptions	as 	old options array
	* @param page			as 	page count
	*
	* @return json
	*/
	async loadOptionsJobs(inputValue, loadedOptions, { page }) {
		try {
			/** Generate source for cancel token */
			this.source = generateSource();

			let response = await callBackendAPI([{ model: 'customer', method: 'customer-code-list', current_page: page, search: inputValue ? inputValue : '' }], this.source);

			let resData = response && response.data && response.data[0] ? response.data[0] : {};
			let result = resData.result ? resData.result : [];
			let recordsTotal = resData.recordsTotal ? resData.recordsTotal : 0;
			let completeArray = result.concat(loadedOptions);

			return {
				options: result,
				hasMore: completeArray.length === recordsTotal ? false : true,
				additional: { page: page + 1 },
			}

		} catch (error) {
			console.error('Error loading options:', error);
			return {
				options: [],
				hasMore: false,
				additional: { page: page },
			};
		}
	}

	/**
	* For manage form submit event
	*
	* @param e 	as 	current form object
	*
	* @return null
	*/
	handleFormSubmit(e) {
		e.preventDefault();

		const { date_range, is_hide_weekend_date, employee_ids, customer_id, skill_id } = this.state.fields;

		let empArr = [];
		if (employee_ids && employee_ids.length) empArr = employee_ids.map(element => element.value);
		this.setState({
			submitted: true,
			fields: {
				...this.state.fields,
				...{
					employees: { value: empArr.length ? empArr : null }
				}
			}
		}, () => {

			let startDate = (date_range && date_range[0]) ? formatDate(date_range[0], CALENDAR_DATE_TIME_FORMAT) : "";
			let endDateDate = (date_range && date_range[1]) ? formatDate(date_range[1], CALENDAR_DATE_TIME_FORMAT) : "";

			/** Employee skill map payload */
			let employeeSkills = [];

			if (
				(this.state.isSkillValidationMode &&
				this.state.empIdsWithoutSkills?.length) ||
				skill_id?.value
			) {

				let empIds = skill_id?.value
					? empArr
					: Object.keys(this.state.employeeSkillMap || {});

				empIds.forEach(empId => {
					let skills = this.state.employeeSkillMap?.[empId] || [];

					employeeSkills.push({
						employee_id: empId,
						skill_ids: skill_id?.value
							? [skill_id.value]
							: skills.map(skill => skill.value)
					});
				});
			}

			/** Api Requested Data **/
			let params = [{
				model: 'on_call',
				method: 'add-employees',
				skill_id: skill_id?.value || "",
				emp_id: this.state.emp_id ? this.state.emp_id : "",
				start_date: startDate,
				end_date: endDateDate,
				include_weekend: (is_hide_weekend_date && is_hide_weekend_date.value) || "",
				employee_ids: empArr,
				customer_code: (customer_id && customer_id?.value) || "",
				customer_name: (customer_id && customer_id?.customer_name) || "",

				employee_skills: employeeSkills
			}];

			/** Validation Rules **/
			let validations = {
				employees: { label: translate('on_call.employee'), "rules": ["select"] },
			}

			/** Employee skill validation */
			let errors = { ...this.state.errors };

			/** Remove old skill errors */
			Object.keys(errors).forEach(key => {
				if (key.startsWith("skill_")) {
					delete errors[key];
				}
			});

			let employeeSkillErrors = {};

			/**
			 * Validate only in skill validation mode
			 */
			if (this.state.isSkillValidationMode && this.state.empIdsWithoutSkills?.length) {
				let hasValidationError = false;
				this.state.empIdsWithoutSkills.forEach(emp => {
					let selectedSkills = this.state.employeeSkillMap?.[emp.value];
					if (!selectedSkills || !selectedSkills.length) {
						hasValidationError = true;
						employeeSkillErrors[`skill_${emp.value}`] = translate('Please select skill set.');
					}
				});

				if (hasValidationError) {
					return this.setState({
						errors: {
							...errors,
							...employeeSkillErrors
						},
						submitted: false
					});
				}
			}

			/** Handle validation and api response **/
			handleFormValidation(validations, this.state.fields, params, true, true, true).then(async (response) => {
				if (!response.success) {
					let empIdsWithoutSkills = response?.data?.emp_ids || [];
					return this.setState({
						errors: response.errors,
						submitted: false,
						empIdsWithoutSkills,
						isSkillValidationMode: empIdsWithoutSkills.length > 0
					});
				}

				if (response.success && response.data.status === STATUS_SUCCESS) {
					/** Hide loader */
					this.closeModal();
				} else if (response.data.message) {
					this.setState({
						// errors: reFormatErrors(response.data.message),
						submitted: false
					});
				}

			}).catch(err => console.log(err));
		});
	}

	/**
   * For update state fields values
   *
   * @param e  	as current field object
   * @param field  as current field name
   *
   * @return null
   */
	handleFormInputs(e, field) {
		let response = handleFormInputs(e, field, this.state.fields);
		this.setState({ response }, () => { });
	}// end handleFormInputs()

	/** Manage input change event */
	handleChange = (fieldName) => (fieldVal) => {
		this.setState((prevState) => {

			const newFields = {
				...prevState.fields,
				[fieldName]: fieldVal
			};

			let updatedState = {fields: newFields};

			/**
			 * Reset only if employee selection actually changed
			 */
			if (fieldName === "employee_ids") {

				let oldIds = (prevState.fields.employee_ids || []).map(emp => String(emp.value)).sort().join(",");
				let newIds = (fieldVal || []).map(emp => String(emp.value)).sort().join(",");
				/**
				 * Only reset when selection changes
				 */
				if (oldIds !== newIds) {
					let errors = { ...prevState.errors };
					Object.keys(errors).forEach(key => {
						if (key.startsWith("skill_")) {
							delete errors[key];
						}
					});

					updatedState = {
						...updatedState,
						errors,
						isSkillValidationMode: false
					};
				}
			}
			return updatedState;
		});
	};

	handleEmployeeSkillChange = (empId, selectedSkills) => {
		this.setState((prevState) => {
			let errors = { ...prevState.errors };
			delete errors[`skill_${empId}`];
			return {
				errors,
				employeeSkillMap: {
					...prevState.employeeSkillMap,
					[empId]: selectedSkills
				}
			};
		});
	};

	/**
	* For hide model
	*
	* @return null
	*/
	closeModal() {
		window.document.body.classList.remove("modal-open");
		window.document.body.classList.remove("overflow-hidden");

		this.props.requestOncallModal(false);
	}// end closeModal()


	render() {
		const { submitted, fields, skillList, empIdsWithoutSkills } = this.state;

		return <>
			<div
				className="modal fade on-call-modal d-block show"
				id="addemployeeModalLabel"
				tabIndex={-1}
				aria-labelledby="add-employeeModalLabel"
				aria-hidden="true"
			>
				<div className="modal-dialog modal-dialog-centered modal-lg">
					<div className="modal-content">
						<div className="modal-header">
							<h2 className="modal-title fs-5" id="add-employeeModalLabel">{translate("on_call.add_on_call_schedule")}</h2>
							<button type="button" className="btn-close" aria-label="Close" onClick={() => this.closeModal()}></button>
						</div>
						<form onSubmit={(event) => this.handleFormSubmit(event, 'AddEmployee')} noValidate>
							<div className="modal-body">
								<div className="row filter-box top-0 mt-3">
									<div className="col-md-6">
										<div className="form-group">
											<label className="mb-1 form-label">{translate("on_call.date_range")} <span className='text-danger'>*</span></label>
											<CustomProvider locale={locale}>
												<DateRangePicker
													value={fields.date_range ? fields.date_range : null}
													format={DATE_RANGE_PICKER_FORMAT}
													size="lg"
													className='form-control input-with-label date-range-picker-common'
													onChange={this.handleChange("date_range")}
													placeholder={translate('reports.search_by_date')}
													cleanable={false}
													ranges={[]}
													editable={false}
												/>
											</CustomProvider>
										</div>
									</div>
									<div className="col-md-6">
										<div className="form-group">
											<label className="mb-1 form-label">{translate("on_call.customer")}</label>
											<AsyncPaginate
												className='custom-react-select '
												loadOptions={this.loadOptionsJobs}
												value={fields.customer_id ? fields.customer_id : null}
												onChange={this.handleChange("customer_id")}
												isClearable={true}
												placeholder={translate("on_call.select_customer")}
												additional={{ page: 1 }}
											/>
											<span className="error text-danger">{this.state.errors["customer_id"]}</span>
										</div>
									</div>
									<div className="col-md-12">
										<div className="form-group multiselect-field">
											<label className="mb-1 form-label">{translate("on_call.employee")} <span className='text-danger'>*</span></label>
											<AsyncPaginate
												className='custom-react-select '
												loadOptions={this.loadOptions}
												value={fields.employee_ids ? fields.employee_ids : null}
												onChange={this.handleChange("employee_ids")}
												isClearable={true}
												placeholder={translate("on_call.select_employee")}
												additional={{ page: 1 }}
												isMulti
											/>
											{empIdsWithoutSkills?.length ? 											
												null
											: <span className="error text-danger">{this.state.errors["employee_ids"]}</span>}
											<span className="error text-danger">{this.state.errors["employees"]}</span>
										</div>
									</div>
								</div>
								{
									empIdsWithoutSkills?.length ? (
										<>
											<div className="col-md-12 mb-3">
												<div className="alert alert-warning d-flex align-items-center mb-0">
													<img
														src={infoIcon}
														className="me-2"
														alt="info-icon"
														style={{ cursor: 'pointer' }}
													/>
													<small className="fw-medium">Please select the skill/s for the below mentioned employees:</small>
												</div>
											</div>

											<div className="row mb-2 d-none d-sm-flex">
												<div className="col-6 form-group">
													<label className="mb-1 form-label">
														{translate("on_call.employee")}
													</label>
												</div>

												<div className="col-6 form-group">
													<label className="mb-1 form-label">
														{/* {translate("on_call.skill_set")} */}
														Skill Set
														<span className='text-danger'>*</span>
													</label>
												</div>
											</div>

											<div className="mobile-box-modal z-0 filter-box top-0 mb-4 mb-sm-0">
												{empIdsWithoutSkills.map((emp) => {
													return (
														<div className="row mt-0 mt-sm-0 z-0" key={emp.value}>

															<div className="col-sm-6 form-group">
																<div className="multiselect-field">
																	<label className="mb-1 form-label d-block d-sm-none">
																		{translate("on_call.employee")}
																	</label>

																	<Select
																		className="custom-react-select"
																		inputId={`emp_${emp.value}`}
																		value={emp}
																		options={empIdsWithoutSkills}
																		isDisabled={true}
																	/>
																</div>
															</div>

															<div className="col-sm-6 form-group">
																<div className="multiselect-field">
																	<label className="mb-1 form-label d-block d-sm-none">
																		{translate("on_call.skill")}
																		<span className='text-danger'>*</span>
																	</label>

																	<Select
																		className="custom-react-select"
																		inputId={`skill_${emp.value}`}
																		value={this.state.employeeSkillMap?.[emp.value] || []}
																		options={skillList}
																		onChange={(selected) =>
																			this.handleEmployeeSkillChange(emp.value, selected)
																		}
																		closeMenuOnSelect={true}
																		isClearable={true}
																		placeholder={translate('Select Skill Set')}
																		isMulti
																	/>

																	<span className="error text-danger">
																		{this.state.errors[`skill_${emp.value}`]}
																	</span>
																</div>
															</div>

														</div>
													);
												})}
											</div>
										</>
									) : null
								}
							</div>
							<div className="modal-footer">
								<button type="button" className="btn btn-outline" data-bs-dismiss="modal" onClick={() => this.closeModal()}>{translate('system.cancel')}</button>
								{/* <button type="button" className="btn btn-fill">{translate('system.submit')}</button> */}
								<button type={submitted ? "button" : "submit"} className="btn btn-fill">
									{translate('system.submit')}{submitted && <i className="spinner-border spinner-border-sm  ms-3" />}
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
			<div className="modal-backdrop fade show"></div>
		</>
	}
}